import * as React from 'react';
import { SVGProps } from 'react';

const IconAltitudeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m11 1 2.553 4.74-.553.553-1-1-1 1-1-1-1 1-.553-.553L11 1ZM14 14V6.707l-1 1-1-1-1 1-1-1-1 1-1-1-.158.158L4 14h10Z"
      fill="#BDCDD9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 13.5a.5.5 0 0 1 .5-.5c.433 0 .782.073 1.077.193.293.12.512.277.685.412l.09.07c.291.23.413.325.683.325.28 0 .401-.109.646-.354l.013-.013c.255-.255.633-.633 1.34-.633.708 0 1.086.378 1.341.633l.013.013c.245.245.367.354.647.354s.401-.109.646-.354l.013-.013c.255-.255.633-.633 1.34-.633.708 0 1.086.378 1.341.633l.013.013c.245.245.367.354.647.354.262 0 .368-.088.64-.314l.087-.072c.166-.136.377-.297.667-.419A2.717 2.717 0 0 1 14.5 13a.5.5 0 0 1 0 1c-.317 0-.529.052-.684.117-.157.066-.28.155-.418.27l-.085.07c-.263.224-.638.543-1.278.543-.708 0-1.086-.378-1.34-.633a1.6 1.6 0 0 0-.014-.013c-.244-.245-.366-.354-.646-.354s-.402.109-.647.354l-.013.013c-.255.255-.633.633-1.34.633-.708 0-1.086-.378-1.34-.633l-.014-.013c-.245-.245-.366-.354-.646-.354s-.402.109-.647.354l-.013.013c-.255.255-.633.633-1.34.633-.633 0-1.02-.31-1.297-.534l-.09-.071a1.856 1.856 0 0 0-.449-.276A1.81 1.81 0 0 0 1.5 14a.5.5 0 0 1-.5-.5Z"
      fill="var(--color-typo-primary)"
    />
    <rect
      x={4}
      y={1}
      width={4}
      height={1}
      rx={0.5}
      fill="var(--color-typo-primary)"
    />
    <path
      d="M6 3 4.5 5h.965v5H4.5L6 12l1.5-2H6.465V5H7.5L6 3Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconAltitudeSizeS;
